import styled from 'styled-components'
import CloseButton from '@pc/components/Works/Panel/shared/CloseButton'

const ModalCloseButton = styled(CloseButton)`
  position: absolute;
  right: -20px;
  top: -20px;
`

export default ModalCloseButton
